// @flow
import React, { useCallback, useMemo, useRef, useEffect } from 'react';
import { get } from 'lodash';
import classNames from 'classnames';
import './Toggle.scss';

type Props = {
  name?: string,
  label?: string,
  description?: string, // a line under the label
  disabled?: boolean,
  onChange?: Function,
  isChecked?: boolean,
};

let descriptionCount = 0;

const Toggle = ({
  isChecked, label, description, disabled, name, onChange,
}:Props) => {
  const inputRef = useRef(null);

  const flatId = useMemo(() => (label ? `${label}-${Date.now()}` : Date.now()), [label]);
  // aria-describedby takes a list of ids split by spaces, so this one has none (flatId has the label's)
  const descriptionId = useMemo(() => {
    descriptionCount += 1;
    return `toggleDescription-${descriptionCount}`;
  }, []);

  const handleChange = useCallback((e: Object) => {
    const checked = get(e, ['target', 'checked'], false);

    if (onChange) {
      onChange({ name, value: !!checked });
    }
  }, [name, onChange]);

  useEffect(() => {
    if (isChecked && inputRef.current) {
      inputRef.current.checked = isChecked;
    }
  }, [isChecked]);

  const labelElement = <label className="toggleLabel" htmlFor={flatId}>{label}</label>;

  return (
    <div className={classNames('toggleHolder', { disabled })}>
      <div className="toggle">
        <input
          type="checkbox"
          role="switch"
          name="toggle"
          className="toggleCheckbox"
          id={flatId}
          checked={isChecked === true}
          disabled={disabled}
          aria-describedby={description ? descriptionId : undefined}
          onChange={handleChange}
          ref={inputRef}
        />
        <label className="toggleTrack" htmlFor={flatId}>
          <span className="toggleInner" />
          <span className="toggleSwitch" />
        </label>
      </div>
      {description ? (
        <div className="toggleText">
          {labelElement}
          <small id={descriptionId} className="toggleDescription">{description}</small>
        </div>
      ) : labelElement}
    </div>
  );
};


export default Toggle;
